import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import { env } from "@dt/util";
import Menu from "./menu";

import Header from "./header";
import Navigation from "./navigation";
import FloatingMenu from "../components/FloatingMenu";

import { lib, event } from "../index";
import NotPermission from "../page/not-permission";
import DownloadCenter from "../page/download-center";
import ImportExcel from "../page/import-excel";
import PersonalCenter from "../page/personal-center";
import PermissionManage from "../account/permission-manage";
import AccountManage from "../account/account-manage";
import RoleManage from "../account/role-manage";
import ImportData from "../page/import-data";
import TemporyUser from "../account/tempory-user";
import AdminUserLog from "../account/logs/admin-user-log";
import AdminRoleLog from "../account/logs/admin-role-log";
import WebRoleLog from "../account/logs/web-role-log";
import WebUserLog from "../account/logs/web-user-log";
import TemporyUserLog from "../account/logs/tempory-user-log";
import deptManage from "../account/dept-manage";
import deptLog from "../account/dept/dept-log";
import deptAddUser from "../account/dept/dept-add-user";

import { message } from "antd";
import "./app.less";
import md5 from "md5";
import { appStore } from "./store";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import AccountPermissionManage from "../account/role-permission";
import RoleAddAccount from "../account/role/role-add-account";

const WrapperPermission = observer(({ appStore }) => {
    const userInfo = toJS(appStore.userInfo);
    let subTitle;
    if (userInfo.type === 2 || lib.config.webToken === "admin") {
        //子账号、或者小二端
        subTitle = "您还未获取使用当前页面的权限，请联系管理员进行设置";
    } else if (userInfo.type === 1) {
        //主账号
        subTitle = "您还未获取使用当前页面的权限，请联系小二进行设置";
    }
    return <NotPermission showExtra={false} subTitle={subTitle} />;
});

/**
 *
 * @param {pageMap} props 组件路由映射表
 * @param {configList} props 配置列表
 */

function App({ pageMap = {}, configList = [] }) {
    let [pageList, setPageList] = useState([]);
    let [menuType, setMenuType] = useState(localStorage[`/style/menuType`] || "col");
    let history = useHistory();
    let [menuList, setMenuList] = useState();

    pageMap = {
        ...pageMap,
        "import-excel": ImportExcel,
        "not-permission": NotPermission,
        "download-center": DownloadCenter,
        "personal-center": PersonalCenter,
        "permission-manage": PermissionManage,
        "account-manage": AccountManage,
        "account-permission-manage": AccountPermissionManage,
        "role-manage": RoleManage,
        "role-add-account": RoleAddAccount,
        "import-data": ImportData,
        "tempory-user": TemporyUser,
        "admin-user-log": AdminUserLog,
        "admin-role-log": AdminRoleLog,
        "web-role-log": WebRoleLog,
        "web-user-log": WebUserLog,
        "tempory-user-log": TemporyUserLog,
        "dept-manage": deptManage,
        "dept-log": deptLog,
        "dept-add-user": deptAddUser,
    };

    function closePage({ url }) {
        let { systemPath } = env;
        let current = decodeURIComponent(window.location.pathname + window.location.search);
        if (!url) {
            url = current;
        }
        let index = pageList.findIndex(item => item.url == url);
        if (url == current) {
            let item = pageList[index - 1] || pageList[index + 1] || { url: `/${systemPath}` };
            history.push(item.url);
        }
        try {
            index >= 0 &&
                pageList[index].refreshEvent &&
                event.off(pageList[index].refreshEvent, pageList[index].refreshFn);
        } catch (e) {
            console.log(e);
        }

        pageList.splice(index, 1);
        setPageList([...pageList]);
    }

    function addPage(page) {
        page.url = decodeURIComponent(page.url);
        if (Object.keys(page.params).length > 0) {
            let r = md5(JSON.stringify(page.params));
            page.url += `&r=${r}`;
        }
        if (!pageList.find(item => item.url === page.url)) {
            pageList.push(page);
            history.push({ pathname: page.url, state: page.params });
            setPageList([...pageList]);
        } else if (page.url.includes("needRefresh=true")) {
            //未知特殊逻辑，本不应该放到通用代码层 fuck
            let index = pageList.findIndex(item => item.url.includes(page.url));
            setPageList(pageList => {
                let urlArr = pageList[index].url.split("?");
                if (urlArr.length > 1) {
                    let param = urlArr[1].split("&"),
                        paramIndex = param.findIndex(item => item.includes("timestamp"));
                    if (~paramIndex) {
                        param[paramIndex] = `timestamp=${+new Date()}`;
                    } else {
                        param.push(`timestamp=${+new Date()}`);
                    }
                    pageList[index].url = `${urlArr[0]}?${param.join("&")}`;
                } else {
                    pageList[index].url += `?timestamp=${+new Date()}`;
                }
                history.push(pageList[index].url);
                return [...pageList];
            });
        } else {
            history.push({ pathname: page.url, state: page.params });
        }
    }

    function init() {
        let { systemPath } = env;
        let pathname = window.location.pathname;
        if (pathname !== `/${systemPath}/` && pathname !== "/") {
            pageList.push({
                url: pathname + decodeURIComponent(window.location.search),
            });
            setPageList([...pageList]);
        }
    }

    useEffect(() => {
        init();
        event.on("add-page", addPage);
        event.on("delete-page", closePage);
        event.on("close-page", closePage);
        window.onresize = () => event.emit("window.resize");
    }, []);
    useEffect(() => {
        if (!lib.config.systemCode) {
            return message.error("缺少参数systemCode");
        }
        let systemCode = lib.config.systemCode;
        lib.request({
            url: "/ucenter-account/current/menuList",
            data: { systemCode },
            success: data => setMenuList(data),
        });
        lib.broadcastPostMessage();
    }, []);

    return (
        <ConfigProvider locale={zhCN}>
            <div className="react-single-app react-single-v2 react-single-bg" id="react-single-app">
                <Header />
                <div className="app-content">
                    {menuList && (
                        <>
                            {menuList.length > 0 ? (
                                <>
                                    <Menu menuList={menuList} />
                                    <Navigation pageList={pageList} pageMap={pageMap} configList={configList} />
                                </>
                            ) : (
                                <WrapperPermission appStore={appStore} />
                            )}
                        </>
                    )}
                </div>
                <FloatingMenu />
            </div>
        </ConfigProvider>
    );
}

function AppRouterWrap(props) {
    return (
        <Router>
            <App {...props} />
        </Router>
    );
}

export default AppRouterWrap;
